(function () {
  'use strict';

  // ---- Reveal elements as they enter the viewport ----
  var animated = document.querySelectorAll('.about-animate');

  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    animated.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    animated.forEach(function (el) {
      el.classList.add('is-inview');
    });
  }

  // ---- Animated count-up for stats ----
  var statNumbers = document.querySelectorAll('.about-stat__number[data-count-target]');

  function animateCount(el) {
    var target = el.getAttribute('data-count-target') || '';
    var match = target.match(/^(\d+(?:[.,]\d+)?)(.*)$/);

    if (!match) {
      el.textContent = target;
      return;
    }

    var endValue = parseFloat(match[1].replace(',', '.'));
    var suffix = match[2] || '';
    var duration = 1200;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(endValue * eased);
      el.textContent = current + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = match[1] + suffix;
      }
    }

    window.requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window && statNumbers.length) {
    var countObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            countObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    statNumbers.forEach(function (el) {
      countObserver.observe(el);
    });
  } else {
    statNumbers.forEach(function (el) {
      el.textContent = el.getAttribute('data-count-target') || '';
    });
  }
})();